<template>
  <runai-select
    dense
    aid="priority-select"
    class="over-quota-select w-lg runai-slim-select"
    :options="priorityOptions"
    :model-value="priority"
    @update:model-value="$emit(EEmitName.UpdateModelValue, $event)"
    outlined
  />
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { RunaiSelect } from "@/components/common/runai-select";
import type { IEntityPrioritySelectOption } from "@/models/org-unit.model";
import { ENTITY_PRIORITY_SELECT_OPTIONS, EEntityPriorityValue } from "@/models/org-unit.model";

enum EEmitName {
  UpdateModelValue = "update-priority",
}

export default defineComponent({
  name: "entity-priority-select",
  components: { RunaiSelect },
  props: {
    priority: {
      type: String as PropType<string>,
      default: EEntityPriorityValue.MediumLow,
    },
  },
  computed: {
    EEmitName(): typeof EEmitName {
      return EEmitName;
    },
    priorityOptions(): IEntityPrioritySelectOption[] {
      return ENTITY_PRIORITY_SELECT_OPTIONS;
    },
  },
});
</script>
